import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/voluntaryWorkResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={8}>
                <DTextField
                    label={resource.fields.organisationName.label}
                    required={resource.fields.organisationName.required}
                    helperText={errors.organisationName?.message}
                    error={!!errors.organisationName}
                    {...register(resource.fields.organisationName.name)}
                    type={resource?.fields?.organisationName?.type}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.startDate.name}
                    label={resource.fields.startDate.label}
                    required={resource.fields.startDate.required}
                    {...register(resource.fields.startDate.name)}
                    error={!!errors.startDate}
                    helperText={errors.startDate?.message}
                    type={resource?.fields?.startDate?.type}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.endDate.name}
                    label={resource.fields.endDate.name}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.endDate.name)}
                    error={!!errors.endDate}
                    helperText={errors.endDate?.message}
                    type={resource?.fields?.endDate?.type}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.hoursAttended.name}
                    label={resource.fields.hoursAttended.label}
                    {...register(resource.fields.hoursAttended.name)}
                    error={!!errors.hoursAttended}
                    helperText={errors.hoursAttended?.message}
                    type={resource?.fields?.hoursAttended?.type}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.natureOfWork.name}
                    label={resource.fields.natureOfWork.label}
                    {...register(resource.fields.natureOfWork.name)}
                    error={!!errors.natureOfWork}
                    helperText={errors.natureOfWork?.message}
                    type={resource?.fields?.natureOfWork?.type}
                />
            </GridItem>
            <GridItem xs={12} md={4}>
                <DTextField
                    name={resource.fields.position.name}
                    label={resource.fields.position.label}
                    {...register(resource.fields.position.name)}
                    error={!!errors.position}
                    helperText={errors.position?.message}
                    type={resource?.fields?.position?.type}
                />
            </GridItem>
        </GridContainer>
    );
}
